module.exports = __webpack_public_path__ + "static/media/Mulish-Regular.c150dc38.woff2";